// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + chunkId + "." + {"60":"f8fd883690","253":"57ffeeeb79","619":"1400077963"}[chunkId] + ".js";
};